import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import debounce from "lodash/debounce";
import _ from "lodash";
import theme from "styles/theme";
import Cart from "components/icons/cart";
//import MoreHoriz from 'material-ui/svg-icons/navigation/more-horiz';
import Star from "components/icons/star";
import Globalize from "globalize";
import { format } from "lib/globalize-util";
import CatalogAddItem from "components/catalog-add-item";
import { merge, $ } from "glamor";
import classNames from "classnames";
import Entry from "models/catalog/entry";
import FlatButton from "material-ui/FlatButton";
import CircularProgress from "material-ui/CircularProgress";
import { Link } from "react-router";
import { FormatMessage } from "react-globalize";
import { ZoomInIcon } from "components/icons/zoom-in";
import Edit from "components/icons/edit";

import IconMenu from "material-ui/IconMenu";
import MenuItem from "material-ui/MenuItem";
import IconButton from "material-ui/IconButton";
import MoreVertIcon from "material-ui/svg-icons/navigation/more-vert";

import TrashIcon from "components/icons/trash";
import { ProductMediaLightBox } from "components/product-media/media-lightbox";
import { utc as utcDate } from "moment";
import NotesIcon from "components/icons/notes";
import ActionMenu from "./action-menu";
import { AccountType } from "types/user";

import { AddIcon } from "components/icons/add";
import { RemoveIcon } from "components/icons/remove";
import siteConfig from "site-config";
import { DATATEST } from "constants/integration";
import { gtm } from "helpers/gtm";

const styles = merge(
    {
        position: "absolute",
        bottom: "-50px",
        left: "0px",
        right: "0px",
        height: "50px",
        backgroundColor: "rgba(255, 255, 255, .8)",
        opacity: 0,
        contain: "layout",
        zIndex: 4,
    },
    $(".hover", {
        bottom: "0px",
        opacity: 1,
    }),
    $(" .content", {
        display: "flex",
        justifyContent: "center",
        padding: "1px 0px",
    }),
    $(".listView", {
        backgroundColor: theme.palette.canvasColor,
    }),
);

const menuStyle = {
    position: "absolute",
    top: "-6px",
    right: "-8px",
    zIndex: 10,
};

const menuStyleLarge = {
    position: "absolute",
    top: "-12px",
    right: "-12px",
    zIndex: 10,
};

class ItemActions extends PureComponent {
    static contextTypes = {
        me: PropTypes.object.isRequired,
        app: PropTypes.object.isRequired,
        router: PropTypes.object.isRequired,
    };

    static propTypes = {
        item: PropTypes.object,
        hover: PropTypes.bool.isRequired,
        catalogEntry: PropTypes.object,
        catalog: PropTypes.object,
        onRequestShowNotes: PropTypes.func,
        onOpenAddItem: PropTypes.func,
        visibleButtons: PropTypes.number,
        activeList: PropTypes.object,
        cart: PropTypes.object,
        isActiveList: PropTypes.bool,
        isTile: PropTypes.bool,
        applyWatermarking: PropTypes.bool,
        onSnackbarAdd: PropTypes.func.isRequired,
        scope: PropTypes.object.isRequired,
        listView: PropTypes.bool,
        actionsOffset: PropTypes.number,
        onEditProduct: PropTypes.func,
    };

    static defaultProps = {
        visibleButtons: 3,
    };

    constructor(props) {
        super(props);
        this.state = {
            addToCatalogOpen: false,
            lightboxIsOpen: false,
            inlineOrderOpen: false,
            inlineOrderQuantity: 1,
            productMedia: null,
            mobileWithinCartOverride:
                window.__mobileApp && window.__mobileApp.cartProductIdentifiers.includes(this.props.item._id),
            mobileWithinListOverride:
                window.__mobileApp && window.__mobileApp.listProductIdentifiers.includes(this.props.item._id),
        };

        this.handlePlaceOrder = this.handlePlaceOrder.bind(this);
        this.handlePreventBubbling = this.handlePreventBubbling.bind(this);
        this.handleAddToCatalog = this.handleAddToCatalog.bind(this);
        this.handleCloseAddToCatalog = this.handleCloseAddToCatalog.bind(this);
        this.handlePlaceSingleSizeOrder = debounce(this.handlePlaceSingleSizeOrder, 750);
        this.handleSetProductMedia = this.handleSetProductMedia.bind(this);

        if (window.__mobileApp) {
            const itemActions = this;
            if (window.__mobileApp.registerCartChanges) {
                window.__mobileApp.registerCartChanges(this.props.item._id, function (withinCart) {
                    itemActions.setState({
                        mobileWithinCartOverride: withinCart,
                    });
                });
            }
            if (window.__mobileApp.registerListChanges) {
                window.__mobileApp.registerListChanges(this.props.item._id, function (withinList) {
                    itemActions.setState({
                        mobileWithinListOverride: withinList,
                    });
                });
            }
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.state.inlineOrderOpen) {
            if (this.props.hover && !nextProps.hover) {
                this.inlineOrderDisplayTimer = setTimeout(() => {
                    this.setState({
                        inlineOrderOpen: false,
                        inlineOrderQuantity: 1,
                    });
                }, 5000);
            } else if (!this.props.hover && nextProps.hover) {
                clearTimeout(this.inlineOrderDisplayTimer);
            }
        }
    }

    componentWillUnmount() {
        clearTimeout(this.disabledTimer);
        clearTimeout(this.inlineOrderDisplayTimer);
    }

    handlePreventBubbling(e) {
        e.preventDefault();
        e.stopPropagation();
    }

    handleAddToCatalog(e) {
        e.preventDefault();
        e.stopPropagation();
        const { me } = this.context;
        const { activeList, item, actions, onSnackbarAdd, catalogEntry, scope } = this.props;

        const style = {
            color: theme.snackbar.actionColor,
            float: "right",
            marginTop: "6px",
            marginRight: "-16px",
            marginLeft: "8px",
            backgroundColor: "transparent",
        };

        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.addItemToListHandler) {
            window.webkit.messageHandlers.addItemToListHandler.postMessage({
                item: item._id,
            });
            return;
        }

        if (activeList && activeList.current && activeList.current.type === "custom-list") {
            const inActiveList = item && activeList.entries.has(item._id);

            if (inActiveList) {
                actions.onActiveListRemove(item._id);
            } else {
                const entry = new Entry();
                actions.onActiveListAdd(item._id);

                entry.save(
                    {
                        item_id: item._id,
                        type: "item",
                        catalogId: activeList.current.id,
                        notes: catalogEntry ? catalogEntry.notes : "",
                        company: scope.viewAs && scope.viewAs._id,
                    },
                    {
                        success: (data) => {
                            const { id, title, _link } = activeList.current;
                            const type = activeList.current.type === "linesheet" ? "linesheet" : "list";

                            gtm.emit(
                                gtm.events.addToWishlist({
                                    currency: me._activeCurrency,
                                    items: [gtm.formatItem(item, scope, type, id, title)],
                                    value: gtm.fetchValueFromItems([item], scope),
                                    send_to: gtm.groups.Brand,
                                }),
                            );
                            me.trackAction("Add item to catalog", {
                                selectAll: false,
                                createNew: false,
                                bulk: false,
                                type,
                            });
                            onSnackbarAdd({
                                message: (
                                    <span>
                                        <FormatMessage
                                            path="Added to catalog"
                                            variables={{
                                                catalog: title,
                                            }}
                                            elements={{
                                                link: <Link to={_link} />,
                                            }}
                                        />
                                        <FlatButton
                                            style={style}
                                            label={Globalize.formatMessage("Undo")}
                                            onClick={() => {
                                                actions.onActiveListRemove(item._id);
                                                entry.destroy();
                                            }}
                                        />
                                        <FlatButton
                                            style={style}
                                            label={Globalize.formatMessage("Change")}
                                            onClick={() => {
                                                actions.onActiveListRemove(item._id);
                                                entry.destroy();
                                                if (actions?.onAddToCatalogOpen) {
                                                    actions.onAddToCatalogOpen();
                                                }
                                                this.setState({
                                                    addToCatalogOpen: true,
                                                });
                                            }}
                                        />
                                    </span>
                                ),
                            });
                        },
                        error: (model, { statusCode, body }) => {
                            let message = format("Error adding product");
                            switch (statusCode) {
                                case 403:
                                    if (_.size(body?.rejectedEntriesGroupedByCause?.warehouse)) {
                                        message = format(
                                            "|n| product(s) could not be added because they are not available in the selected warehouse.",
                                            {
                                                n: _.size(body.rejectedEntriesGroupedByCause.warehouse),
                                            },
                                        );
                                    }
                                    break;
                                case 409:
                                    message = (
                                        <FormatMessage
                                            path="Product already added to catalog"
                                            variables={{
                                                catalog: activeList.current.title,
                                            }}
                                            elements={{
                                                link: <Link to={activeList.current._link} />,
                                            }}
                                        />
                                    );
                                    break;
                                default:
                                    message = format("Error adding product");
                                    break;
                            }

                            if (statusCode !== 409) {
                                actions.onActiveListRemove(item._id);
                            }

                            onSnackbarAdd({ message });
                        },
                    },
                );
            }
        } else {
            this.setState({ addToCatalogOpen: true });
            if (actions?.onAddToCatalogOpen) {
                actions.onAddToCatalogOpen();
            }
        }
    }

    handleCloseAddToCatalog() {
        const { actions } = this.props;
        if (actions?.onAddToCatalogClose) {
            actions.onAddToCatalogClose();
        }
        this.setState({ addToCatalogOpen: false });
    }

    handlePlaceOrder(e) {
        e.preventDefault();
        e.stopPropagation();

        const { app, me } = this.context;
        const { item, cart, listView, catalogEntry, catalogDates, scope } = this.props;
        const { inlineOrderQuantity } = this.state;

        if (cart) {
            if (cart.items.has(item._id)) {
                app.trigger("remove-from-cart", {
                    item,
                });

                me.trackAction("Remove from order", {
                    selectAll: false,
                    bulk: false,
                    resource: "item-card",
                });

                this.setState({
                    disabled: true,
                    inlineOrderOpen: false,
                    inlineOrderQuantity: 1,
                });

                this.disabledTimer = setTimeout(() => {
                    this.setState({ disabled: false });
                }, 1000);
            } else {
                const addOptions = {
                    item,
                };

                if (listView && item.__sizes.size === 1) {
                    const size = item.get("__sizes").get(0);
                    addOptions.params = {
                        sizes: [
                            {
                                size: size.__size,
                                quantity: inlineOrderQuantity,
                            },
                        ],
                    };
                    this.setState({ inlineOrderOpen: true });
                }

                if (catalogDates && catalogDates.ship_start && catalogDates.ship_end && !item.__out_of_range) {
                    addOptions.params = addOptions.params ? addOptions.params : {};
                    addOptions.params.ship_start = catalogDates.ship_start;
                    addOptions.params.ship_end = catalogDates.ship_end;
                    addOptions.params.fromCatalog = true;
                    if (
                        item &&
                        scope.brand.hasPreference("enforce_available_until") &&
                        item.__available_until &&
                        item.__available_until.isBefore(utcDate(catalogDates.ship_end), "day")
                    ) {
                        addOptions.params.ship_end = item.__available_until.clone().valueOf();
                    }

                    if (
                        item.__available_from &&
                        item.__available_from.isAfter(utcDate(catalogDates.ship_start), "day")
                    ) {
                        addOptions.params.ship_start = item.__available_from.clone().valueOf();
                    }

                    // Server does this too, but better to send correct data to begin with.
                    if (utcDate(addOptions.params.ship_start).isBefore(utcDate(), "day")) {
                        addOptions.params.ship_start = utcDate().valueOf();
                    }

                    addOptions.params.prebook = catalogDates.catalogPrebook;
                }

                if (catalogEntry) {
                    addOptions.params = addOptions.params ? addOptions.params : {};
                    addOptions.params.catalog_id = catalogEntry.catalog_id;
                }

                app.trigger("add-to-cart", addOptions);

                me.trackAction("Add to order", {
                    selectAll: false,
                    bulk: false,
                    resource: "item-card",
                });
            }

            this.setState({ disabled: true });

            this.disabledTimer = setTimeout(() => {
                this.setState({ disabled: false });
            }, 1000);
        }
    }

    handlePlaceSingleSizeOrder = (quantity) => {
        const { item, cart } = this.props;
        const { app, me } = this.context;
        const size = item.get("__sizes").get(0);
        const toast = false;
        let inCart = false;

        if (cart) {
            if (cart.items.has(item._id)) {
                inCart = true;
                app.trigger("remove-from-cart", {
                    item,
                    toast,
                });
            }

            const data = {
                sizes: [
                    {
                        size: size.__size,
                        quantity: quantity,
                    },
                ],
                inCart,
            };

            app.trigger("add-to-cart", {
                item,
                params: data,
            });

            me.trackAction("Add to order", {
                selectAll: false,
                bulk: false,
                resource: "product-list",
            });

            this.setState({
                disabled: true,
            });

            this.disabledTimer = setTimeout(() => {
                this.setState({ disabled: false });
            }, 1000);
        }
    };

    handleOpenLightbox = (event) => {
        event.nativeEvent.stopImmediatePropagation();

        this.setState({ lightboxIsOpen: true });
    };

    handleCloseLightbox = () => {
        this.setState({ lightboxIsOpen: false });
    };

    handleSetProductMedia = (productMedia) => {
        this.setState({ productMedia });
    };

    handleInlineOrder = (e) => {
        this.handlePreventBubbling(e);
        const key = e.currentTarget.getAttribute("data-key");
        const { inlineOrderQuantity } = this.state;
        let newQuantity;

        if (key === "input") {
            newQuantity = e.target.value === "" ? 0 : parseInt(e.target.value, 10);
        } else {
            newQuantity = inlineOrderQuantity === "" ? 0 : parseInt(inlineOrderQuantity, 10);
            if (key === "decrement") {
                newQuantity -= 1;
            } else if (key === "increment") {
                newQuantity += 1;
            }
        }

        this.setState({ inlineOrderQuantity: newQuantity < 0 ? 0 : newQuantity });
        if (!Number.isNaN(newQuantity) && newQuantity >= 0) {
            this.handlePlaceSingleSizeOrder(newQuantity);
        }
    };

    render() {
        const { me, app } = this.context;
        const {
            onDelete,
            editable,
            hover,
            item,
            catalogEntry,
            catalog,
            visibleButtons,
            activeList,
            actions,
            inActiveList,
            inOrder,
            onSnackbarAdd,
            isActiveList,
            scope,
            listView,
            onRequestShowNotes,
            actionsOffset,
            onEditProduct,
            isTile,
        } = this.props;

        const {
            addToCatalogOpen,
            disabled,
            lightboxIsOpen,
            inlineOrderOpen,
            inlineOrderQuantity,
            mobileWithinCartOverride,
            mobileWithinListOverride,
        } = this.state;

        let mobileKabob;
        if (app.touchDevice && !listView) {
            const menuItems = [];
            if (catalogEntry && editable) {
                menuItems.push(
                    <MenuItem
                        key={"delete"}
                        leftIcon={<TrashIcon color={theme.palette.darkGrey} />}
                        primaryText={Globalize.formatMessage("Delete")}
                        onClick={onDelete}
                    />,
                );
            }
            if (item && visibleButtons < 3) {
                menuItems.push(
                    <MenuItem
                        key={"zoom"}
                        leftIcon={<ZoomInIcon color={theme.palette.darkGrey} />}
                        primaryText={Globalize.formatMessage("Zoom In")}
                        onClick={this.handleOpenLightbox}
                    />,
                );
            }
            if (isTile && visibleButtons < 3) {
                menuItems.push(
                    <MenuItem
                        key={"edit"}
                        leftIcon={<Edit color={theme.palette.darkGrey} />}
                        primaryText={Globalize.formatMessage("Edit")}
                        onClick={this.props.onEditProduct}
                    />,
                );
            }
            if (menuItems.length) {
                mobileKabob = (
                    <IconMenu
                        iconButtonElement={
                            <IconButton>
                                <MoreVertIcon color={theme.palette.darkGrey} />
                            </IconButton>
                        }
                        anchorOrigin={{ horizontal: "right", vertical: "top" }}
                        targetOrigin={{ horizontal: "right", vertical: "top" }}
                        style={visibleButtons === 3 ? menuStyleLarge : menuStyle}
                        onClick={this.handlePreventBubbling}
                    >
                        {menuItems}
                    </IconMenu>
                );
            }
        }

        const isCustomizable = item && item.isCustomizable(scope);
        const isOpen =
            hover ||
            inActiveList ||
            (inOrder && !isCustomizable) ||
            inlineOrderOpen ||
            (catalogEntry && catalogEntry.notes) ||
            !window.matchMedia("(pointer:fine)").matches;

        let content;
        if (isOpen && item) {
            let orderButton = null;
            if (!isCustomizable && me.hasPermission("can_order") && item.isAvailable(scope)) {
                if (disabled) {
                    orderButton = (
                        <CircularProgress
                            style={{
                                marginTop: "18px",
                                marginRight: "8px",
                                marginLeft: "8px",
                            }}
                            size={16}
                            thickness={1}
                        />
                    );
                } else {
                    orderButton = (
                        <IconButton
                            onClick={this.handlePlaceOrder}
                            disabled={disabled}
                            data-test={DATATEST.GALLERY.ITEM_CART_BUTTON}
                        >
                            <Cart
                                color={
                                    inOrder || mobileWithinCartOverride
                                        ? theme.palette.primary1Color
                                        : theme.palette.darkGrey
                                }
                                hoverColor={theme.palette.darkerGrey}
                                aria-label={
                                    inOrder || mobileWithinCartOverride
                                        ? "Remove from Cart " + item._id
                                        : "Add to Cart " + item._id
                                }
                                data-test={DATATEST.GALLERY.ITEM_CART_ICON}
                            />
                        </IconButton>
                    );
                }
            }

            content = (
                <div className="content">
                    {listView &&
                        me.account_type !== AccountType.BUYER &&
                        siteConfig.EDIT_PRODUCT_ENABLED === "true" && (
                            <ActionMenu
                                onEditProduct={onEditProduct}
                                hover={true}
                                value={catalogEntry ? catalogEntry : item}
                                list={listView}
                            />
                        )}
                    {orderButton}
                    <IconButton onClick={this.handleAddToCatalog} disabled={isActiveList}>
                        <Star
                            color={
                                inActiveList || mobileWithinListOverride
                                    ? theme.palette.primary1Color
                                    : theme.palette.darkGrey
                            }
                            data-test="item-recommend"
                            aria-label={
                                inActiveList || mobileWithinListOverride
                                    ? "Remove from List " + item._id
                                    : "Add to List " + item._id
                            }
                        />
                    </IconButton>
                    {visibleButtons > 2 && (
                        <IconButton onClick={this.handleOpenLightbox}>
                            <ZoomInIcon color={theme.palette.darkGrey} hoverColor={theme.palette.darkerGrey} />
                        </IconButton>
                    )}
                    {catalogEntry && listView && (
                        <IconButton onClick={onRequestShowNotes}>
                            <NotesIcon
                                fill={catalogEntry.notes ? theme.palette.primary1Color : theme.palette.darkGrey}
                                hoverColor={theme.palette.darkerGrey}
                            />
                        </IconButton>
                    )}
                    {catalogEntry && editable && listView && (
                        <IconButton onClick={onDelete}>
                            <TrashIcon color={theme.palette.darkGrey} hoverColor={theme.palette.darkerGrey} />
                        </IconButton>
                    )}
                </div>
            );
        }

        let inlineOrder;
        if (item && inlineOrderOpen) {
            const inlineOrderStyle = {
                container: {
                    position: "absolute",
                    left: actionsOffset && listView ? `${actionsOffset - 165}px` : "0px",
                    backgroundColor: theme.palette.canvasColor,
                    width: "165px",
                },
                input: {
                    width: "65px",
                    borderRadius: "4px",
                    textAlign: "right",
                    transform: "translateY(-6px)",
                },
            };

            let inlineOrderValue = "";
            if (inlineOrderQuantity) {
                inlineOrderValue = inlineOrderQuantity.toString();
            }

            inlineOrder = (
                <div style={inlineOrderStyle.container}>
                    <IconButton onClick={this.handleInlineOrder} data-key="decrement">
                        <RemoveIcon color={theme.palette.darkGrey} />
                    </IconButton>
                    <input
                        type="text"
                        style={inlineOrderStyle.input}
                        value={inlineOrderValue}
                        onChange={this.handleInlineOrder}
                        placeholder={Globalize.formatMessage("Qty")}
                        data-key="input"
                        autoFocus={inlineOrderOpen}
                        onClick={this.handlePreventBubbling}
                    />
                    <IconButton onClick={this.handleInlineOrder} data-key="increment">
                        <AddIcon color={theme.palette.darkGrey} />
                    </IconButton>
                </div>
            );
        }

        return (
            <div>
                {item && lightboxIsOpen && (
                    <ProductMediaLightBox
                        open={true}
                        product={item}
                        onClose={this.handleCloseLightbox}
                        onSetMedia={this.handleSetProductMedia}
                        scope={scope}
                    />
                )}
                {inlineOrder}
                <div
                    {...styles}
                    className={classNames({ hover: isOpen })}
                    style={{
                        left: actionsOffset && listView ? `${actionsOffset}px` : "0px",
                        transition: listView ? "initial" : "all .2s ease-in-out",
                    }}
                    onClick={this.handlePreventBubbling}
                    data-test={DATATEST.GALLERY.ITEM_ACTIONS}
                >
                    {content}
                </div>
                {addToCatalogOpen && (
                    <CatalogAddItem
                        activeList={activeList}
                        onActiveListAdd={actions.onActiveListAdd}
                        onActiveListRemove={actions.onActiveListRemove}
                        onActiveListFetchEntries={actions.onActiveListFetchEntries}
                        onSetActiveList={actions.onSetActiveList}
                        item={item}
                        currentCatalog={catalog}
                        open={addToCatalogOpen}
                        onSnackbarAdd={onSnackbarAdd}
                        onRequestClose={this.handleCloseAddToCatalog}
                        scope={scope}
                    />
                )}
                {mobileKabob}
            </div>
        );
    }
}

export default ItemActions;
